import React, { useState, useEffect } from 'react';
import createMark from '../../../api/cars/createMark';
import { useNavigate } from 'react-router-dom';

// components
import Form from '../../../components/Form/Form';
import Header from '../../../components/Header/Header';

// icons
import icon from '../../../brand/generated/sidebar/cars.svg';

const formStyles = {
  marks: { display: 'grid', gap: '20px', gridTemplateColumns: `1fr` },
};

const CarMarksCreate = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState([{ type: 'input', value: undefined, label: 'ÐÐ°ÑÐºÐ°', placeholder: 'Ð£ÐºÐ°Ð¶Ð¸ÑÐµ Ð¼Ð°ÑÐºÑ' }]);

  const handleSubmit = () => {
    if (!form[0].value) return;

    let mark = form[0].value;
    mark = mark.charAt(0).toUpperCase() + mark.slice(1);
    createMark({ name: mark })
      .then(() => {
        navigate('/cars/marks');
      })
      .catch((err) => alert(err));
  };

  return (
    <>
      <Header title={'ÐÐ¾Ð²Ð°Ñ Ð¼Ð°ÑÐºÐ°'} icon={icon} />
      <div style={{ paddingBottom: '20px' }}>
        <Form
          inputs={form}
          handlerSetState={setForm}
          title={'ÐÐ°ÑÐºÐ° Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ'}
          grid={formStyles.marks}
          border
          action={'Ð¡Ð¾ÑÑÐ°Ð½Ð¸ÑÑ'}
          handleSubmit={handleSubmit}
        />
      </div>
    </>
  );
};

export default CarMarksCreate;
